import React from 'react';

const CtyunLogo = () => (
  <img 
  src="https://www.ctyun.cn/s/q04sv38ZSzTBF4mEHo-3dVsyWITNHb2AHhoKmmcfMQvFLURsx3V4aUR26W8PQUqCT8irIp8kNZZFmZcjQa3tK6eXmmMshjNGFvsiB8BbIGaFz_TPP8FfRddLJaCyZHeBXWsC1L62ycvoisuSuYDeDRtmnH44p_kJ" 
  alt="天翼云" 
  style={{ width: '160px', height: 'auto' }}
/>
);

export default CtyunLogo;